/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Old/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import AdditionalOptions from './AdditionalOptions/index'
import AppointmentData from './AppointmentData/index'
import AppointmentSelect from './AppointmentSelect/index'
import Footer from './Footer/index'
import Header from './Header/index'
import LoadingState from './LoadingState/index'
import PatientPreview from './PatientPreview/index'
import PatientSelect from './PatientSelect/index'
import React from 'react'
import ScheduleOptions from './ScheduleOptions/index'
import SimilarPatients from './SimilarPatients/index'
import TreatmentSelect from './TreatmentSelect/index'
import TypeAndDuration from './TypeAndDuration/index'
import TysiaOverlay from 'DesignSystem/TysiaOverlay/index'
import TysiaOverlayContent from 'DesignSystem/TysiaOverlay/TysiaOverlayContent/index'
import TysiaOverlayFooter from 'DesignSystem/TysiaOverlay/TysiaOverlayFooter/index'
import TysiaOverlayHeader from 'DesignSystem/TysiaOverlay/TysiaOverlayHeader/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Old({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old"
  
}) {
let appointmentOverlayDockedToLeftValueData = fromData.useDataValue({ viewPath,
context: 'appointment_overlay',
path: 'docked_to_left',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
  return (<React.Fragment
>
<AppointmentData
  viewPath={`${viewPath}/AppointmentData`}
/>
<TysiaOverlay
  viewPath={`${viewPath}/TysiaOverlay`}
 left={appointmentOverlayDockedToLeftValueData ? dtSpaceS : "auto"}
 right={appointmentOverlayDockedToLeftValueData ? "auto" : dtSpaceS}
 data="appointment_overlay.docked_to_left"
>
{childProps => (
<React.Fragment>
<TysiaOverlayHeader
{...childProps}
  viewPath={`${viewPath}/TysiaOverlayHeader`}
>
{childProps => (
<Header
{...childProps}
  viewPath={`${viewPath}/Header`}
/>
)}
</TysiaOverlayHeader>
<TysiaOverlayContent
{...childProps}
  viewPath={`${viewPath}/TysiaOverlayContent`}
>
{childProps => (
<React.Fragment>
<LoadingState
{...childProps}
  viewPath={`${viewPath}/LoadingState`}
/>
<div
  data-testid="Old.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-lk6': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-2-lk6': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-3-lk6': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-lk6': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-5-lk6': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<PatientSelect
  viewPath={`${viewPath}/PatientSelect`}
/>
<PatientPreview
  viewPath={`${viewPath}/PatientPreview`}
/>
<TreatmentSelect
  viewPath={`${viewPath}/TreatmentSelect`}
/>
<div
  data-testid="Old.Vertical:1"
  data-view-path={viewPath}
 style={{'--g-5-lk6': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<AppointmentSelect
  viewPath={`${viewPath}/AppointmentSelect`}
/>
<TypeAndDuration
  viewPath={`${viewPath}/TypeAndDuration`}
/>
<ScheduleOptions
  viewPath={`${viewPath}/ScheduleOptions`}
/>
<AdditionalOptions
  viewPath={`${viewPath}/AdditionalOptions`}
/>
</div>
<SimilarPatients
  viewPath={`${viewPath}/SimilarPatients`}
/>
</div>
</React.Fragment>
)}
</TysiaOverlayContent>
<TysiaOverlayFooter
{...childProps}
  viewPath={`${viewPath}/TysiaOverlayFooter`}
>
{childProps => (
<Footer
{...childProps}
  viewPath={`${viewPath}/Footer`}
/>
)}
</TysiaOverlayFooter>
</React.Fragment>
)}
</TysiaOverlay>
{children}
</React.Fragment>)
}